var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'd-flex d-flex-c chart-wrapper mb-1',
    _vm.wrapperType,
    { 'is-flex': _vm.isFlex },
  ]},[_c('label',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.label))]),(_vm.showCount)?_c('div',{staticClass:"count"},[_vm._v(" "+_vm._s(_vm.chartConfig.count)),(_vm.chartConfig.team)?_c('span',{staticClass:"team-count"},[_vm._v("/"+_vm._s(_vm.chartConfig.teamCount))]):_vm._e()]):_vm._e(),(_vm.chartType)?_c('div',{staticStyle:{"height":"calc(100% - 4em)"}},[_c('chart',{attrs:{"type":_vm.chartType,"config":_vm.chartConfig}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }